import { optionsAuth } from "@seabrookstudios/auth";
import { get, post } from "../network";

/**
 * @param {import("@seabrookstudios/types").Url} url
 * @param {import("@seabrookstudios/auth").TokenString} token
 * @param {string} name
 * @param {Function} onSuccess
 * @param {Function} onError
 */
export const useUploadImage = (url, token, name, onSuccess, onError) => {
  const process = async (_fieldName, file, _metadata, load, error, progress, abort) => {
    const formData = new FormData();
    formData.append(name, file, file.name);

    const request = new XMLHttpRequest();
    request.open("POST", url);
    request.setRequestHeader("Authorization", `Bearer ${token}`);

    request.upload.onprogress = (e) => {
      progress(e.lengthComputable, e.loaded, e.total);
    };

    request.onload = function () {
      if (request.status >= 200 && request.status < 300) {
        load(request.responseText);
        onSuccess(request.responseText);
      } else {
        error("oh no");
        onError();
      }
    };

    request.send(formData);

    return {
      abort: () => {
        request.abort();
        abort();
      },
    };
  };

  return process;
};

/**
 * @param {import("@seabrookstudios/types").Url} url
 * @param {import("@seabrookstudios/auth").TokenString} token
 * @param {string} name
 * @param {Function} onSuccess
 * @param {Function} onError
 */
export const useUploadPdfBlob = (url, token, name, onSuccess, onError) => {
  /**
   * @param {Blob} blob
   * @param {string} filename
   */
  const process = async (blob, filename) => {
    const formData = new FormData();
    formData.append(name, blob, filename);

    const request = new XMLHttpRequest();

    return new Promise((resolve, reject) => {
      request.open("POST", url);
      request.setRequestHeader("Authorization", `Bearer ${token}`);

      request.onload = function () {
        if (request.status >= 200 && request.status < 300) {
          resolve(request.responseText);
          onSuccess(request.responseText);
        } else {
          reject();
          onError();
        }
      };

      request.send(formData);

      return {
        abort: () => {
          request.abort();
        },
      };
    });
  };

  return process;
};

/**
 * @param {string} startUrl
 * @param {import("@seabrookstudios/auth").TokenString} token
 * @param {Function} onSuccess
 * @param {Function} onError
 */
export const usePreSignedUploadImage = (startUrl, finishUrl, token, onSuccess, onError) => {
  const process = async (_fieldName, file, _metadata, load, error, progress, abort) => {
    try {
      const response = await get(startUrl, optionsAuth(token));
      const { url } = response.data;

      const request = new XMLHttpRequest();
      request.open("PUT", url, true);

      request.upload.onprogress = (e) => {
        progress(e.lengthComputable, e.loaded, e.total);
      };

      request.onload = async function () {
        if (request.status >= 200 && request.status < 300) {
          const finish = await post(finishUrl, { type: file.type, name: file.name }, optionsAuth(token));
          load(request.responseText);
          onSuccess(finish.data);
        } else {
          error("oh no");
          onError();
        }
      };

      request.send(file);

      return {
        abort: () => {
          request.abort();
          abort();
        },
      };
    } catch (e) {
      onError();
    }
  };

  return process;
};
